module.exports = __webpack_public_path__ + "assets/img/footer2.780bea03.png";